/* eslint-disable no-unused-vars */
import { FC, memo } from "react";
import { FormItem, Input } from "formik-antd";

import { Styles } from "../styled";
import { useConfirmingLeave } from "@lhd/app/index";

type IProps = {
  name: string;
  label?: string;
  className?: string;
  required?: boolean;
  placeholder?: string;
  disabled?: boolean;
  isLeaveForm?: boolean;
  rows?: number;
  onChange?: (e: any) => void;
  setFieldValue?: (field: string, value: any) => void;
  maxLength?: number;
  fieldValue?: string;
  showCount?: boolean;
  boldLabel?: boolean;
};

const InputAreaField = memo(function InputAreaField({
  name,
  label,
  required = false,
  className,
  placeholder = "",
  disabled = false,
  rows,
  setFieldValue,
  fieldValue,
  onChange,
  isLeaveForm = false,
  maxLength,
  showCount = false,
  boldLabel = false,
}: IProps) {
  const { checkLeaveForm } = useConfirmingLeave();

  return (
    <Styles className="text-area" isLabelBold={boldLabel}>
      <FormItem
        name={name}
        label={label}
        className={className}
        required={required}
      >
        <Input.TextArea
          rows={rows || 5}
          placeholder={placeholder}
          maxLength={maxLength}
          name={name}
          onBlur={(e) =>
            setFieldValue && setFieldValue(name, e.target.value.trim())
          }
          disabled={disabled}
          onChange={(e: any) => {
            onChange && onChange(e);
            isLeaveForm && checkLeaveForm();
          }}
          autoComplete="off"
        />
        {showCount && (
          <div className="text-area__count">
            {fieldValue?.length || 0}/{maxLength}
          </div>
        )}
      </FormItem>
    </Styles>
  );
});

export default InputAreaField;
